
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]",
      function () {
        return require("private-next-pages/stores/[cName].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]"])
      });
    }
  